import { css } from 'emotion'
import RcTooltip from 'rc-tooltip'
import * as React from 'react'

import { useTheme } from 'embed/hooks'
import { TooltipProps } from 'rc-tooltip/lib/Tooltip'
import classnames from 'classnames'

require('./styles')

export type TriggerType = 'hover' | 'click' | 'focus'
export type PlacementType = 'left' | 'right' | 'top' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'

export interface Props extends TooltipProps {
  children: React.ReactElement
  onToggle?: (e: boolean) => void
}

export const Tooltip: React.FC<Props> = ({
  children = <></>,
  overlay = () => null,
  overlayStyle = {},
  placement = 'bottomRight',
  trigger = ['hover', 'click'],
  onToggle = () => {},
  visible,
  overlayClassName,
}) => {
  const { borderRadiusLarge } = useTheme()
  const visibleProp = typeof visible === 'boolean' ? { visible } : {}
  return (
    <RcTooltip
      overlayClassName={classnames(
        overlayClassName,
        css`
          .rc-tooltip-inner {
            border-radius: ${borderRadiusLarge};
          }
        `,
      )}
      children={children}
      overlay={overlay}
      overlayStyle={overlayStyle}
      onVisibleChange={onToggle}
      placement={placement}
      trigger={trigger}
      {...visibleProp}
    />
  )
}
